<template>
    <Fragment>
        <VueScene
                ref="fade_out"
                :keyframes="keyframes_fadeout"
                :autoplay=false
                @ended="onFadedOut">
            <span></span>
        </VueScene>
        <VueScene
                ref="fade_in"
                :keyframes="keyframes_fadein"
                :autoplay=false
                @ended="onFadedIn">
            <span></span>
        </VueScene>
        <div class="apppage playbackpage" id="playbackpage" :style="showContent? 'display:block':'display: none'">

            <div class="titlecontainer">
<!--                <VueScene ref="titleFadeIn" :keyframes="title_fadein" :autoplay=false>-->
                    <div class="playbacktitle" :class="showEndTile?'transp':''">
                        {{videoTitle}}
                    </div>
<!--                </VueScene>-->
            </div>
            <div class="vimeoContainer" v-if="videoId !== '' && visible">
                <div class="vimeoShape">
                    <vueVimeoPlayer
                            class="vimeo"
                            ref="vidplayer"
                            :video-id='videoId'
                            :options="{ responsive: true }"
                            @ended="onVideoEnded"
                            @ready="onVideoReady">
                    </vueVimeoPlayer>
                </div>
                <div class="endTile" v-if="showEndTile && !isMobile()">
                    <div class="shroud">
                    </div>
                    <div class="endTileMessage">you have discovered 1 of a possible 21 audio visual combinations</div>

                    <button class="wizard_btn new_film_btn" @click="$emit('restart')">
                        create new film
                    </button>
                </div>
            </div>
            <div class="endTileMobile" v-if="showEndTile && isMobile()">
                <div class="shroud">
                </div>
                <div class="endTileMessage">you have discovered 1 of a possible 21 audio visual combinations</div>

                <button class="wizard_btn new_film_btn" @click="$emit('restart')">
                    create new film
                </button>
            </div>
            <div class="info" v-if="!showEndTile">
                <div class="infotext">this is 1 of a possible 21 film combinations</div>
            </div>

            <button v-if="!showEndTile" ref="create_new_film" class="wizard_btn smallwiz opacityfaded" @click="onCreateNewFilm">create new film</button>

        </div>
    </Fragment>

</template>

<script>

    import { VueScene } from "vue-scenejs";
    import { Fragment } from 'vue-fragment'
    import { vueVimeoPlayer } from 'vue-vimeo-player'
    import {default as vidmap} from '@/vidmap';

    export default {
        name: 'PlaybackPage',
        components:{
            VueScene,
            Fragment,
            vueVimeoPlayer
        },
        methods:{
            onChoose: function(choice) {
                let idx = this.choices.indexOf(choice);
                if(idx === -1){
                    this.choices.push(choice);
                } else {
                    this.choices.splice(idx, 1);
                }
            },
            onCreateNewFilm: function() {
                if(this.$refs.create_new_film.classList.contains('opaque')){
                    this.$emit('restart');
                }
            },
            onFadedOut: function() {
                this.showContent = false;
                this.canPlayWhenReady = false;
                this.videoReady = false;
            },
            onFadedIn: function() {
                this.canPlayWhenReady = true;
                if(this.videoReady){
                    this.$refs.vidplayer.play(); /* Both the fade-in needs to be complete, and the video needs to be ready before .play() */
                    this.$refs.create_new_film.classList.remove("opaque");
                    setTimeout(() => {
                        this.$refs.create_new_film.classList.add("opaque");
                    }, 7000);
                }
                //this.$refs.titleFadeIn.play();
            },
            onVideoReady: function() {
                this.videoReady = true;
                if(this.canPlayWhenReady){
                    this.$refs.vidplayer.play(); /* Both the fade-in needs to be complete, and the video needs to be ready before .play() */
                    this.$refs.create_new_film.classList.remove("opaque");
                    setTimeout(() => {
                        this.$refs.create_new_film.classList.add("opaque");
                    }, 7000);
                }
            },
            onVideoEnded: function() {
                if (document.fullscreenElement !== null && document.exitFullscreen) {
                    document.exitFullscreen();
                }
                this.showEndTile = true;
            },
            isMobile() {
                console.log(navigator.userAgent);
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        },
        props: {
            initiallyVisible: Boolean,
            videoChoice: String,
            audioChoice: String,
        },
        watch: {
            visible: function(newVal) {
                this.showContent = true;

                if(newVal){
                    this.showEndTile = false;
                    this.$refs.fade_in.play();
                } else{
                    this.$refs.fade_out.play();
                }
            }
        },
        computed: {
            videoId: function() {
                if(Object.prototype.hasOwnProperty.call(vidmap.ids, this.videoChoice)) {
                    var audioOpts = vidmap.ids[this.videoChoice];
                    if(Object.prototype.hasOwnProperty.call(audioOpts, this.audioChoice)) {
                        return audioOpts[this.audioChoice];
                    }
                }

                return "";
            },
            videoTitle: function() {
                if(Object.prototype.hasOwnProperty.call(vidmap.titles, this.videoChoice)) {
                    var audioOpts = vidmap.titles[this.videoChoice];
                    if(Object.prototype.hasOwnProperty.call(audioOpts, this.audioChoice)) {
                        return "playing ‘"+audioOpts[this.audioChoice]+"’";
                    }
                }

                return "";
            }
        },
        data() {
            return {
                visible: this.initiallyVisible,
                showContent: this.initiallyVisible,
                showEndTile: false,
                videoReady: false,
                canPlayWhenReady: false,
                "title_fadein": {
                    ".playbacktitle": () => ({
                        0: {
                            "opacity": 0
                        },
                        4: {
                            "opacity": 0
                        },
                        5: {
                            "opacity": 1
                        },
                    })
                },
                "keyframes_fadeout": {
                    "#playbackpage": () => ({
                        0: {
                            "opacity": 1
                        },
                        0.5: {
                            "opacity": 0
                        },
                        easing: "linear"
                    }),
                },
                "keyframes_fadein": {
                    "#playbackpage": () => ({
                        0: {
                            "opacity": 0
                        },
                        0.5: {
                            "opacity": 1
                        },
                        easing: "linear"
                    }),
                }
            };
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import "../assets/styles/variables";

    .transp {
        opacity:0;
    }

    .playbackpage{

        .endTileMobile {
            position: absolute;
            width: 100%;
            height: 100%;
            top:0;
            left:0;


            .endTileMessage {
                font-family: Cormorant, 'serif';
                font-style: normal;
                font-weight: 500;
                font-size: 28px;
                text-align: center;

                color: #FFFFFF;
                position: absolute;
                top: 10%;
                width: calc(100% - 60px);
                margin: 0 30px;
            }

            .shroud {
                background-color: rgba(0,0,0,0.7);
                width: 100%;
                height: calc(100% + 88px);
                margin-top: -88px;
            }
        }

        .titlecontainer {
            overflow: hidden;

            .playbacktitle {
                font-family: Cormorant, 'serif';
                font-style: normal;
                font-weight: 500;
                font-size: 24px;
                line-height: 29px;
                text-align: center;
                margin: 60px auto 30px auto;
                width: 80%;

                position: relative;
                @media only screen and (max-height : 773px) {
                    display: none;
                }
            }
        }
        .smallwiz{

            width: 240px;
            height: 33px;
            left: calc(50% - 240px / 2);

        }
        .info {
            overflow: hidden;

            .infotext {
                font-family: Lato, 'sans-serif';
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                text-align: center;
                margin: 65px auto 30px auto;
                position: relative;
                color: #fff;
                max-width: 80%;
                line-height: 19px;
                @media only screen and (max-height : 773px) {
                    display: none;
                }

            }
            .textbutton {
                color: #fff;
                display: block;
                margin: 0 auto;
                font-family: Lato,sans-serif;
                font-style: normal;
                font-weight: 300;
                font-size: 16px;
                line-height: 19px;
                border: 0;
                background-color: transparent;
            }
        }

        .vimeoContainer{
            //background: aqua;
            max-width: calc(((var(--vh, 1vh) * 60) - 60px - 80px) * 1.777777);
            min-height: calc((var(--vh, 1vh) * 60) - 60px - 80px);
            //height: calc((var(--vh, 1vh) * 60) - 60px - 80px);
            margin: 0 auto;
            filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
            @media (max-aspect-ratio: 1/1) {
                max-width: calc(90vw - 80px);
                min-height: calc(90vw / 1.777777 - 80px);
            }
            @media only screen and (max-height : 773px) {
                max-width: calc(((var(--vh, 1vh) * 75) - 60px - 80px) * 1.777777);
                max-height: calc((var(--vh, 1vh) * 75) - 60px - 80px);
                margin-top:20px;
            }
            @media only screen and (max-height : 550px) { // No header bar at this height
                max-width: calc(((var(--vh, 1vh) * 85) - 90px) * 1.777777);
                max-height: calc((var(--vh, 1vh) * 85) - 90px);
                margin-top:-70px;
            }

            .vimeoShape {
                .vimeo {
                    flex: 0 1 auto;
                    align-self: auto;
                }
            }

            .endTile {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                .new_film_btn {
                    bottom:25%;
                    //@media only screen and (max-height: 575px) {
                    //    bottom:45%;
                    //    max-width: 90%;
                    //    width: 90%;
                    //    margin: 0 auto;
                    //    left: 5%;
                    //}
                }

                .endTileMessage {
                    font-family: Cormorant, 'serif';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 28px;
                    text-align: center;

                    color: #FFFFFF;
                    position: absolute;
                    top: 30%;
                    width: calc(100% - 60px);
                    margin: 0 30px;
                    @media only screen and (max-height: 550px) {
                        top: 20%;
                        font-size: 24px;
                        line-height: 26px;
                    }
                }

                .shroud {
                    background-color: rgba(0,0,0,0.7);
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

</style>
